module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/KnightFight.1fe0596.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/KnightFight.jpg
// module id = C6R3
// module chunks = 0